(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["membership-tier"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.button = this.querySelector('button[type="submit"]');
          this.label = this.querySelector('.membership-tier__button-label');
          this.defaultLabel = this.label ? this.label.textContent : '';
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }

        async onSubmit(event) {
          event.preventDefault();
          if (this.button.disabled) return;

          const usePlugAnimation = this.dataset.plugAnimation === 'true';
          const plugOverlay = document.querySelector('plug-in-overlay');
          const overlay = usePlugAnimation ? plugOverlay : null;

          this.button.disabled = true;
          this.button.classList.add('is-loading');
          if (overlay) {
            overlay.showOverlay();
          } else if (this.label) {
            this.label.textContent = this.dataset.addingText || this.defaultLabel;
          }

          const formData = new FormData(this.form);
          const variantId = formData.get('id');
          const sellingPlanId = formData.get('selling_plan');

          // The plug-in animation runs on a fixed ~1.6s clock regardless of
          // network speed, so slow connections don't cut it short and fast
          // ones don't skip it.
          const minDelay = overlay ? new Promise((resolve) => setTimeout(resolve, 1600)) : null;

          try {
            // These are subscription tiers — a customer should only ever
            // have one in their cart at a time. Every add here carries a
            // hidden `_membership_group` line item property, so any other
            // cart line marked with it is a conflicting tier to remove first.
            const [outgoingTitle] = await Promise.all(
              [this.removeConflictingMembership(variantId), minDelay].filter(Boolean)
            );

            const membershipItem = {
              id: variantId,
              quantity: 1,
              properties: { _membership_group: 'true' },
            };
            if (sellingPlanId) membershipItem.selling_plan = sellingPlanId;

            const body = JSON.stringify({
              items: [membershipItem],
              sections: 'cart-drawer',
              sections_url: window.location.pathname,
            });

            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body,
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || 'Add to cart failed');

            if (data.sections && data.sections['cart-drawer']) {
              const parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
              const newDrawer = parsed.querySelector('cart-drawer');
              const oldDrawer = document.querySelector('cart-drawer');
              if (newDrawer && oldDrawer) {
                oldDrawer.replaceWith(newDrawer);
                document.dispatchEvent(
                  new CustomEvent('cart:updated', {
                    detail: { itemCount: Number(newDrawer.dataset.itemCount) },
                  })
                );

                // /cart/add.js returns { items: [...] } (not a flat line item)
                // when the request body uses the `items` array format, as
                // this one does.
                const incomingTitle = data.items && data.items[0] ? data.items[0].product_title : null;
                const swapMessage = outgoingTitle
                  ? (plugOverlay?.dataset.swapTemplate || 'Switched from {from} to {to}')
                      .replace('{from}', outgoingTitle)
                      .replace('{to}', incomingTitle)
                  : null;

                if (overlay) {
                  overlay.dismissOverlay();
                }

                if (swapMessage && plugOverlay) {
                  // A swap needs its own explanation — the drawer alone
                  // doesn't make clear that another plan was just removed.
                  // The drawer still opens afterward for consistency with
                  // every other add-to-cart flow; it's just sequenced after
                  // the toast so the two don't visually collide (the drawer
                  // is a native <dialog> whose backdrop would otherwise dim
                  // the toast).
                  plugOverlay.showToast(swapMessage, () => newDrawer.open());
                } else {
                  newDrawer.open();
                }
              }
            }
          } catch (error) {
            console.error(error);
            if (overlay) overlay.dismissOverlay();
            this.showError(error.message, plugOverlay);
          } finally {
            this.button.disabled = false;
            this.button.classList.remove('is-loading');
            if (this.label) this.label.textContent = this.defaultLabel;
          }
        }

        // Shopify's own "maximum quantity" error is generic ("The maximum
        // quantity of this item is already in your cart.") and doesn't read
        // naturally for a subscription tier — swap in a message that
        // explains *why* in that specific case, shown the same way as every
        // other cart confirmation. Anything else falls back to a plain alert.
        showError(message, plugOverlay) {
          if (message && /maximum quantity/i.test(message) && plugOverlay) {
            plugOverlay.showToast(
              plugOverlay.dataset.quantityLimitTemplate ||
                "You're already plugging in! You have a Membership in your cart waiting for checkout."
            );
            return;
          }
          window.alert(this.dataset.errorText);
        }

        // Looks for an existing cart line from another membership product
        // and removes it. Returns that line's product title (for the swap
        // confirmation message) or null if there was nothing to remove.
        async removeConflictingMembership(newVariantId) {
          let cart;
          try {
            cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
          } catch (error) {
            console.error(error);
            return null;
          }

          const conflicting = cart.items.find(
            (item) =>
              item.properties &&
              item.properties._membership_group === 'true' &&
              String(item.variant_id) !== String(newVariantId)
          );
          if (!conflicting) return null;

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: conflicting.key, quantity: 0 }),
          });

          return conflicting.product_title;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
